/**
 * Plain-text cap the BE enforces on `body_raw_input`. Counted in Unicode code
 * points to match Django's `len()`.
 */
export const MAX_PLAIN_TEXT_CHARS = 2000
